module.exports = __webpack_public_path__ + "static/media/Kite_orange.c9249d98.png";